import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import _ from 'lodash';

export enum SelectTableDialogType {
  SELECT_ITEM_TABLE,
  SELECT_VENDOR_TABLE,
}

export interface SelectTableDialogData {
  type: SelectTableDialogType;
  initialSelectedNumbers?: number[];
  initialSelectedStrings?: string[];
  filterNumbers?: number[];
  filterStrings?: string[];
  title: string;
  actionButtonText: string;
}

export interface SelectTableDialogActionResult {
  data: {
    selectedNumbers?: number[];
    selectedStrings?: string[];
  };
}

export type SelectTableDialogResult = undefined | SelectTableDialogActionResult;

@Component({
  selector: 'app-select-table-dialog',
  templateUrl: './select-table-dialog.component.html',
  styleUrls: ['./select-table-dialog.component.scss'],
})
export class SelectTableDialogComponent implements OnInit {
  public selectedNumbers: number[] = [];
  public selectedStrings: string[] = [];

  constructor(
    public dialogRef: MatDialogRef<SelectTableDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: SelectTableDialogData
  ) {}

  ngOnInit() {
    if (this.data.initialSelectedNumbers) {
      this.selectedNumbers = this.data.initialSelectedNumbers;
    }
    if (this.data.initialSelectedStrings) {
      this.selectedStrings = this.data.initialSelectedStrings;
    }
  }

  onDialogAction() {
    const result: SelectTableDialogActionResult = {
      data: {},
    };

    if (this.data.initialSelectedNumbers) {
      result.data.selectedNumbers = _.cloneDeep(this.selectedNumbers);
    }
    if (this.data.initialSelectedStrings) {
      result.data.selectedStrings = _.cloneDeep(this.selectedStrings);
    }

    this.dialogRef.close(result);
  }

  public onTableNumberSelectedChange(event: number[]) {
    this.selectedNumbers = event;
  }

  public onTableStringSelectedChange(event: string[]) {
    this.selectedStrings = event;
  }

  public get SelectTableDialogType(): typeof SelectTableDialogType {
    return SelectTableDialogType;
  }
}
